// Estado global único (singleton)
let globalData: Object = {};

// API del dashboard
function addDashboardData(value: Object) {
    globalData = {
        ...globalData,
        ...value
    }
}

function getDashboardData (): Object {
    return globalData;
}

function resetDashboardData(filters: FiltersUI) {
    globalData = {
        currentFilters: filters
    };
}

// Hook para usar desde cualquier componente
export function useDashboardContext() {
    return {
        addDashboardData,
        getDashboardData,
        resetDashboardData,
    };
}
